import { render } from "./OrderCellAddress.vue?vue&type=template&id=190e17ad&scoped=true"
import script from "./OrderCellAddress.vue?vue&type=script&lang=js"
export * from "./OrderCellAddress.vue?vue&type=script&lang=js"

import "./OrderCellAddress.vue?vue&type=style&index=0&id=190e17ad&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-190e17ad"]])

export default __exports__